import { AxiosResponse } from "axios";
import { IResponseResult } from "@/services/data/base_types";
import base_ds from "@/services/base_datasource_service";
import {Tariff, TariffHistoryType} from "@/services/models-service";
import request from "@/utils/request";


export const route_ns = `tariff_history`;

class TariffHistoryService {
    public current: TariffHistoryType | null = null;
    public crud = base_ds.getBaseCrud(route_ns);
    public data_source = base_ds.getBaseDataSource(route_ns);

    public setCurrent(value: TariffHistoryType) {
      this.current = value;
    }

    public async getById(entity_id: string): Promise<IResponseResult<TariffHistoryType>> {
      const response: AxiosResponse["data"] = await this.crud.get_by_id(entity_id);
      if (response) {
        return response;
      } else {
        return { data: null, message: "" };
      }
    }

  public async getWithFilter(id_cut: string, id_node: string): Promise<IResponseResult<Tariff[]>> {
    const route = route_ns+`?filter=[["id_cut","=","${id_cut}"],"and",["id_heat_node","=","${id_node}"]]`;
    const response: AxiosResponse["data"] = await request({
      url: route,
      method: "get",
    });
    if (response) {
      return response;
    } else {
      return { data: null };
    }
  }


}

export default new TariffHistoryService();
